/* AagamStuti festive calendar. Plain JavaScript, no libraries.
   Draws the home strip ([data-fc="strip"]) and the moving strip at the top of the page ([data-fc="ticker"]) from the festival files.
   The calendar page ([data-fc="page"]) is drawn by aagamstuti-festival-page.js, which uses the helpers shared from here.
   Dates are plain YYYY-MM-DD strings for New Delhi; "today" is always worked out in India Standard Time.
   Data: assets/festival-calendar.json holds the dates; the guides sit in festival-calendar.json and festival-calendar-guides-*.json.
   A section lists every file in data-src (the first one) and data-parts (the others, separated by spaces). */
(function () {
  'use strict';

  if (window.__asFestivals) { window.__asFestivals.scan(); return; }

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DAYFULL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- dates ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function todayIST() {
    var d = new Date(Date.now() + 330 * 60000); // India Standard Time is UTC+5:30
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
  }
  function utc(s) { var p = s.split('-'); return Date.UTC(+p[0], +p[1] - 1, +p[2]); }
  function diff(a, b) { return Math.round((utc(b) - utc(a)) / 864e5); }
  function addDays(s, n) { var d = new Date(utc(s) + n * 864e5); return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function parts(s) { var d = new Date(utc(s)); return { y: d.getUTCFullYear(), m: d.getUTCMonth(), d: d.getUTCDate(), w: d.getUTCDay() }; }
  function short(s) { var p = parts(s); return DAY[p.w] + ' ' + p.d + ' ' + MON[p.m]; }
  function endOf(e) { return e.end || e.date; }

  /* ---------- tiny DOM helper ---------- */
  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'class') el.className = v;
      else if (k === 'text') el.textContent = v;
      else el.setAttribute(k, v === true ? '' : v);
    });
    (kids || []).forEach(function (c) { if (c) el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }

  /* ---------- data ---------- */
  var cache = {};
  function fetchOne(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  function merge(list) {
    var out = { guides: {}, events: [] };
    list.forEach(function (d) {
      Object.keys(d.guides || {}).forEach(function (k) { out.guides[k] = d.guides[k]; });
      out.events = out.events.concat(d.events || []);
    });
    return out;
  }
  function load(root) {
    var urls = [root.getAttribute('data-src')].concat((root.getAttribute('data-parts') || '').split(/\s+/)).filter(Boolean);
    var key = urls.join(' ');
    if (!cache[key]) cache[key] = Promise.all(urls.map(fetchOne)).then(merge);
    return cache[key];
  }
  function build(data) {
    var today = todayIST();
    var list = (data.events || []).map(function (e) {
      var g = data.guides[e.guide] || {};
      return { id: e.id, date: e.date, end: e.end || null, note: e.note || '', g: g, name: g.name || e.id };
    }).filter(function (e) { return endOf(e) >= today; });
    list.sort(function (a, b) { return a.date < b.date ? -1 : a.date > b.date ? 1 : 0; });
    return { today: today, list: list };
  }
  function status(e, today) {
    if (e.date <= today && endOf(e) >= today) {
      if (e.date === endOf(e)) return { kind: 'today', label: 'Today' };
      var last = diff(today, endOf(e));
      return { kind: 'live', label: last === 0 ? 'Last day' : 'On now' };
    }
    var n = diff(today, e.date);
    if (n === 1) return { kind: 'soon', label: 'Tomorrow' };
    if (n < 0) return { kind: 'gone', label: '' };
    return { kind: 'later', label: 'In ' + n + ' days', n: n };
  }
  function whenText(e) {
    return e.end && e.end !== e.date ? short(e.date) + ' to ' + short(e.end) : short(e.date);
  }

  /* ---------- icons (the theme's own icon snippet, rendered into <template>s by the section) ---------- */
  function icon(root, name) {
    var t = root.querySelector('[data-fc-icons] [data-name="' + name + '"]');
    var s = t && t.content ? t.content.firstElementChild : null;
    return s ? s.cloneNode(true) : null;
  }

  function pill(st) {
    return h('span', { class: 'as-fpill as-fpill--' + st.kind, text: st.label });
  }
  function dateTile(e) {
    var p = parts(e.date);
    return h('div', { class: 'as-fdate' }, [
      h('span', { class: 'as-fdate__m', text: MON[p.m] }),
      h('span', { class: 'as-fdate__d', text: String(p.d) }),
      h('span', { class: 'as-fdate__w', text: DAY[p.w] })
    ]);
  }
  function setStatus(root, text) {
    var el = root.querySelector('[data-fc-status]');
    if (el) { el.textContent = text; el.hidden = !text; }
  }

  /* ---------- home strip ---------- */
  function renderStrip(root, data) {
    var b = build(data);
    var count = parseInt(root.getAttribute('data-count'), 10) || 4;
    var page = root.getAttribute('data-page') || '';
    var body = root.querySelector('[data-fc-body]');
    var items = b.list.slice(0, count);
    body.textContent = '';
    setStatus(root, '');
    if (!items.length) {
      if (window.Shopify && window.Shopify.designMode) setStatus(root, 'No upcoming festivals are left in the list. The festival file needs the next dates added.');
      else root.hidden = true;
      return;
    }
    var ul = h('ul', { class: 'as-fs__list', role: 'list' });
    items.forEach(function (e, i) {
      var st = status(e, b.today);
      var g = e.g, shop = g.shop || {};
      var name = page ? h('a', { class: 'as-fs__link', href: page + '#' + e.id, text: e.name }) : document.createTextNode(e.name);
      var li = h('li', { class: 'as-fs__card' + (i === 0 ? ' as-fs__card--next' : '') }, [
        h('div', { class: 'as-fs__top' }, [dateTile(e), pill(st)]),
        h('h3', { class: 'as-fs__name' }, [name]),
        g.hindi ? h('span', { class: 'as-fs__hi as-sacred', lang: 'hi', text: g.hindi }) : null,
        h('p', { class: 'as-fs__when', text: whenText(e) }),
        h('p', { class: 'as-fs__sum', text: g.summary || '' }),
        shop.url ? h('a', { class: 'as-ulink as-fs__shop', href: shop.url, text: shop.label || 'Shop the pooja' }) : null
      ]);
      ul.appendChild(li);
    });
    body.appendChild(ul);
  }

  /* ---------- moving strip at the top of the page ---------- */
  function tickMeta(e, st) {
    if (st.kind === 'today') return 'Today';
    if (st.kind === 'live') return st.label === 'Last day' ? 'Last day' : 'On now, until ' + short(endOf(e));
    if (st.kind === 'soon') return 'Tomorrow, ' + short(e.date);
    return short(e.date) + ', ' + st.label.toLowerCase();
  }
  function renderTicker(root, data) {
    var b = build(data);
    var count = parseInt(root.getAttribute('data-count'), 10) || 6;
    var page = root.getAttribute('data-page') || '';
    var speed = { slow: 30, normal: 45, fast: 65 }[root.getAttribute('data-speed')] || 45; // pixels per second
    var view = root.querySelector('[data-fc-view]');
    var track = root.querySelector('[data-fc-track]');
    var btn = root.querySelector('[data-fc-pause]');
    var items = b.list.slice(0, count);
    track.textContent = '';
    if (!items.length) {
      if (window.Shopify && window.Shopify.designMode) track.appendChild(h('span', { class: 'as-ftick__meta', text: 'No upcoming festivals are left in the list. The festival file needs the next dates added.' }));
      else root.hidden = true;
      return;
    }
    // One run of the list. Copies are hidden from screen readers and from the tab order.
    function makeSet(reps, copy) {
      var set = h('div', { class: 'as-ftick__set', 'aria-hidden': copy ? 'true' : null });
      for (var r = 0; r < reps; r++) items.forEach(function (e) {
        var st = status(e, b.today), dim = copy || r > 0;
        var kids = [h('span', { class: 'as-ftick__name', text: e.name }), h('span', { class: 'as-ftick__meta', text: tickMeta(e, st) })];
        var el = page
          ? h('a', { class: 'as-ftick__item', href: page + '#' + e.id, tabindex: dim ? '-1' : null }, kids)
          : h('span', { class: 'as-ftick__item' }, kids);
        if (dim && !copy) el.setAttribute('aria-hidden', 'true');
        set.appendChild(el);
        set.appendChild(h('i', { class: 'as-ftick__sep', 'aria-hidden': 'true' }));
      });
      return set;
    }
    function layout() {
      track.textContent = '';
      track.style.removeProperty('--ftick-dur');
      var first = makeSet(1, false);
      track.appendChild(first);
      if (reduce) { if (btn) btn.hidden = true; return; } // still, and scrollable by hand
      // repeat the list until one run is wider than the strip, then loop two runs by half their width
      var w = first.getBoundingClientRect().width || 1;
      var reps = Math.max(1, Math.ceil((view.clientWidth + 48) / w));
      track.textContent = '';
      track.appendChild(makeSet(reps, false));
      track.appendChild(makeSet(reps, true));
      var unit = track.firstChild.getBoundingClientRect().width || w;
      track.style.setProperty('--ftick-dur', Math.max(12, unit / speed).toFixed(1) + 's');
      if (btn) btn.hidden = false;
    }
    layout();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    var lastW = window.innerWidth, timer;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      clearTimeout(timer);
      timer = setTimeout(layout, 200);
    });
    if (btn && !btn.__asFc) {
      btn.__asFc = true;
      btn.addEventListener('click', function () {
        var on = btn.getAttribute('aria-pressed') !== 'true';
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        root.classList.toggle('is-paused', on);
      });
    }
  }

  /* ---------- start ---------- */
  function init(root) {
    if (root.__asFc) return;
    var kind = root.getAttribute('data-fc');
    var F = window.__asFestivals;
    if (kind === 'page' && !(F && F.page)) return; // the page script calls scan() once it is ready
    root.__asFc = true;
    load(root).then(function (data) {
      if (kind === 'strip') renderStrip(root, data);
      else if (kind === 'ticker') renderTicker(root, data);
      else F.page.render(root, data);
    }).catch(function () {
      if (kind === 'ticker') { root.hidden = true; return; }
      setStatus(root, 'The festive calendar could not load just now. Please refresh the page.');
    });
  }
  function scan(ctx) {
    Array.prototype.slice.call((ctx || document).querySelectorAll('[data-fc]')).forEach(init);
  }
  window.__asFestivals = {
    scan: scan,
    page: null,
    kit: {
      MONTHS: MONTHS, MON: MON, DAY: DAY, DAYFULL: DAYFULL, reduce: reduce,
      pad: pad, addDays: addDays, parts: parts, short: short, endOf: endOf, h: h,
      build: build, status: status, whenText: whenText, icon: icon, pill: pill, dateTile: dateTile, setStatus: setStatus
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();